import debounce from 'lodash-es/debounce';
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import SliderCartAddons from './SliderCartAddons.jsx';
import SliderCartAddonsMobile from './SliderCartAddonsMobile.jsx';

const handleCartDidUpdate = () => {
  try {
    if (window.cart.item_count > 0) {
      document.querySelectorAll('[data-cart-header-not-empty]').forEach((el) => (el.style.display = 'block'));
      document.querySelectorAll('[data-cart-header-empty]').forEach((el) => (el.style.display = 'none'));
    } else {
      document.querySelectorAll('[data-cart-header-not-empty]').forEach((el) => (el.style.display = 'none'));
      document.querySelectorAll('[data-cart-header-empty]').forEach((el) => (el.style.display = 'block'));
    }
  } catch (error) {
    console.log(error);
  }
};

const viewports = {
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
};

const getViewport = () => {
  return window.innerWidth < 768 ? viewports.MOBILE : viewports.DESKTOP;
};

const handleResize = debounce(() => {
  document.dispatchEvent(new Event('debouncedResize'));
}, 500);

window.addEventListener('resize', handleResize);

const SliderCartAddOnsContainer = (props) => {
  const [currentViewport, setCurrentViewport] = useState(getViewport());

  const resizeFn = () => {
    setCurrentViewport(getViewport());
  };

  useEffect(() => {
    document.addEventListener('debouncedResize', resizeFn);

    return () => {
      document.removeEventListener('debouncedResize', resizeFn);
    };
  }, []);

  return (
    <div className="SliderCartAddOnsContainer">
      {props.viewport === viewports.DESKTOP && currentViewport === viewports.DESKTOP && (
        <SliderCartAddons
          items={props.items}
          promo={props.promo}
          promoData={props.promoData}
          viewport={props.viewport}
        />
      )}

      {props.viewport === viewports.MOBILE && currentViewport === viewports.MOBILE && (
        <SliderCartAddonsMobile
          items={props.items}
          promo={props.promo}
          promoData={props.promoData}
          viewport={props.viewport}
        />
      )}
    </div>
  );
};

SliderCartAddOnsContainer.defaultProps = {
  items: [],
  promoData: {},
  viewport: viewports.DESKTOP,
};

export default () => {
  const sliderCartAddOnsElements = document.querySelectorAll('[data-slider-cart-add-ons]');
  if (sliderCartAddOnsElements.length === 0) {
    return;
  }

  sliderCartAddOnsElements.forEach((el) => {
    const viewport = getViewport();

    if (el.getAttribute('initialized') === 'true') {
      return;
    }

    el.setAttribute('initialized', 'true');

    const promoDataStr = decodeURIComponent(el.getAttribute('data-promo'));
    const promoData = JSON.parse(promoDataStr);

    ReactDOM.render(
      <SliderCartAddOnsContainer items={[]} promo={promoData} promoData={promoData} viewport={viewport} />,
      el,
    );
  });

  const sliderCartAddOns = document.querySelector('[data-cart-add-ons]');
  const sliderToggle = document.querySelector('[data-slider-cart-toggle]');
  const sliderClose = document.querySelector('[data-close-slider-cart]');
  const cart = document.querySelector('[data-cart]');

  document.addEventListener('cartDidOpen', () => {
    if (sliderCartAddOns) sliderCartAddOns.classList.add('SliderCartAddOns--open');
    handleCartDidUpdate();
  });

  document.addEventListener('menusWillClose', () => {
    if (sliderCartAddOns) {
      sliderCartAddOns.classList.remove('SliderCartAddOns--open');
      cart.classList.remove('SliderCart--collapsed');
      sliderCartAddOns.classList.remove('SliderCartAddOns--expand');
      sliderClose?.classList.remove('SliderCart__close-button--collapsed'); // TODO: It is no longer employed. This could be removed on WIN-7193
    }
  });

  if (sliderToggle) {
    sliderToggle.addEventListener('click', () => {
      sliderToggle.classList.toggle('SliderCart__toggle--flipped');
      cart.classList.toggle('SliderCart--collapsed');
      sliderCartAddOns.classList.toggle('SliderCartAddOns--expand');
      sliderClose.classList.toggle('SliderCart__close-button--collapsed');
    });
  }

  document.querySelectorAll('[data-cart-add-ons] [data-add-to-cart]').forEach((el) => {
    el.addEventListener('click', () => {
      if (!cart.classList.contains('SliderCart--collapsed')) {
        return true;
      }

      const currentBreakpoint = window.theme.breakpoints.current;
      if (currentBreakpoint === 'mobile' || currentBreakpoint === 'tablet') {
        sliderToggle.click();
      }

      return true;
    });
  });
};
